import { Typography } from '@mui/material';
import _ from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';

import ResponsiveDialog from '@sophocles/components/ResponsiveDialog';

function DeleteCameraDialog({ cameraId, open, onDeleteCamera, onClose, canSubmit = true }) {
  const { t } = useTranslation();
  const handleSubmit = () => {
    return onDeleteCamera(cameraId);
  };

  return (
    <ResponsiveDialog
      title={t('sites.deleteCamera', 'Delete Camera')}
      open={open}
      onClose={onClose}
      onSubmit={handleSubmit}
      canSubmit={canSubmit}
      submitText={t('actions.delete', 'Delete')}
      maxWidth="xs"
      sx={{ '& .MuiDialogContent-root > :not(style)': { mb: 2 } }}
    >
      <Typography>{t('sites.deleteCameraConfirm', 'Are you sure you want to delete this camera?')}</Typography>
    </ResponsiveDialog>
  );
}

export default DeleteCameraDialog;
